// get all
export const FLAG_GETTING_TICKETS = 'FLAG_GETTING_TICKETS';
export const GET_TICKETS = 'GET_TICKETS';
export const CLEAR_TICKETS = 'CLEAR_TICKETS';

// get one
export const FLAG_TICKET_ACTIVITY = 'FLAG_TICKET_ACTIVITY';
export const GET_TICKET = 'GET_TICKET';
export const CLEAR_TICKET = 'CLEAR_TICKET';
export const FLAG_CHANGING_PASSENGER = 'FLAG_CHANGING_PASSENGER';

export const GET_CUSTOMER_UPDATE_HISTORY = 'GET_CUSTOMER_UPDATE_HISTORY';
export const CLEAR_CUSTOMER_UPDATE_HISTORY = 'CLEAR_CUSTOMER_UPDATE_HISTORY';
export const FLAG_GETTING_CUSTOMER_UPDATE_HISTORY = 'FLAG_GETTING_CUSTOMER_UPDATE_HISTORY';

export const GET_TICKET_FROM_ITINERARY = 'GET_TICKET_FROM_ITINERARY';
export const CLEAR_TICKET_FROM_ITINERARY = 'CLEAR_TICKET_FROM_ITINERARY';
export const FLAG_GETTING_TICKET_FROM_ITINERARY = 'FLAG_GETTING_TICKET_FROM_ITINERARY';

export const PRINT_TICKET_VOUCHER_ON_MOUNT = 'PRINT_TICKET_VOUCHER_ON_MOUNT';
